import { html, LitElement, nothing, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';
import { handleKeyboardTrigger } from '../../base/package/util/a11y';
import { DevicePointerType, devicePointerType } from '../../base/package/util/device';
import { dispatchCustomEvent } from '../../base/package/util/event';
import styles from './ui-filter.css?inline';
import './ui-filter-item';

export type FilterItem = {
  active?: boolean;
  name: string;
  slug: string;
};

export type FilterSelectDetail = {
  name: string;
  slug: string;
};

const CName = 'ui-filter';

/**
 * @fires select - When a filter item is selected
 */
@customElement(CName)
export class UIFilter extends LitElement {
  static readonly styles = unsafeCSS(styles);

  @property({ type: String }) class = '';
  @property({ type: Boolean }) href = false;
  @property({ type: Boolean }) button = false;
  @property({ type: Array }) items: FilterItem[] = [];

  private readonly _deviceTypeClass = devicePointerType() === DevicePointerType.MOUSE ? 'desktop' : '';

  render() {
    const className = `filter-wrapper ${this._deviceTypeClass} ${this.class}`;
    return html`
      <ul class=${className}>
        ${repeat(
          this.items,
          (item) => item.slug,
          (item) => {
            return html`
              <li>
                ${
                  this.href
                    ? html`
                      <a class="seo-link" href=${window.$app.router.getPathNavigateToTag(item.slug)} @click=${(ev: PointerEvent) => ev.preventDefault()}>
                        ${this._renderFilterItem(item)}
                      </a>
                    `
                    : this._renderFilterItem(item)
                }
              </li>
            `;
          },
        )}
      </ul>
    `;
  }

  private _renderFilterItem(item: FilterItem) {
    return html`
        <ui-filter-item
          @click=${() => this._handleClick(item.name, item.slug)}
          .active=${item.active ?? false}
          .useButton=${this.button}
          .label=${item.name}
          class=${this.class}
          aria-current=${item.active ? 'page' : nothing}
          @keydown=${(ev: KeyboardEvent) => handleKeyboardTrigger(ev, this._handleClick.bind(this, item.name, item.slug))}
        ></ui-filter-item>
    `;
  }

  private _handleClick(name: string, slug: string) {
    const payload: FilterSelectDetail = { name, slug };
    dispatchCustomEvent(this, 'select', payload);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UIFilter;
  }
}
